import React from "react";
import { DialogActionsProps as MuiDialogActionsProps, DialogActions as MuiDialogActions } from "@mui/material";
import useDialogClasses from "../Dialog/useDialogClasses";

export default function DialogActions({ className, ...rest }: MuiDialogActionsProps): React.ReactElement {
  const { actions } = useDialogClasses();
  return <MuiDialogActions className={`${actions} ${className ?? ""}`} {...rest} />;
}
